import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ── PWA: register the service worker + capture the native install prompt ──
// The `beforeinstallprompt` event fires early (before React mounts), so we
// capture it at the module level and stash it for the seller install prompt.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__fabInstallPrompt = e;
  window.dispatchEvent(new Event("fab-install-available"));
});
window.addEventListener("appinstalled", () => {
  window.__fabInstallPrompt = null;
  window.__fabInstalled = true;
  window.dispatchEvent(new Event("fab-installed"));
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
